import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import microsoftPartnerLogo from "../../Assets/images/micro-partner.png";
import footerlogo from "../../Assets/images/footer_logo.png";
import { useNavigate } from "react-router-dom";
import { apiBaseURL } from "../../Common/ApiHelper";
const Footer = () => {
  const navigate = useNavigate();
  const HandleAccount = () => {
    if (localStorage.getItem("token")) {
      navigate("/order_summary");
    } else {
      navigate("/login");
    }
  };
  return (
    <div className="footer_outer_container">
      <footer className="footer_container">
        <div className="darkblue_bg footer_upper_info">
          <Container>
            <p className="text-white text-center mb-0">
              Click The Chat Icon or Call (833) 465 0300 To Speak With Someone
              Now!
            </p>
            <button
              className="footer_support_btn"
              onClick={() => navigate("/support")}
            >
              Need Sales & Support?
            </button>
          </Container>
        </div>
        <div className="menus_wrapper">
          <Container>
            <Row>
              <Col md="3">
                <div className="footer_logo_wrapper align_center">
                  <img
                    src={footerlogo}
                    alt="footer logo"
                    className="footer_logo"
                  />
                  <p className="footer_address">
                    {/* 1546 BW 56th Street New York, NY 10009 */}
                    2248 Broadway #1721 New York, NY 10024 United States
                  </p>
                  <img src={microsoftPartnerLogo} alt="logo" />
                </div>
              </Col>
              <Col md="2">
                <div className="footer_quick_links align_center">
                  <h5>Help Center</h5>
                  <ul>
                    <li onClick={() => navigate("/support")}>Get Support</li>
                    <li onClick={() => navigate("/remote_assistance")}>
                      Remote Assistance
                    </li>
                    <li onClick={() => navigate("/asked_questions")}>
                      Frequently Asked Questions
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md="2">
                <div className="footer_quick_links align_center">
                  <h5>Shopping</h5>
                  <ul>
                    <li onClick={HandleAccount}>My Account</li>
                    <li onClick={() => navigate("/cart")}>View Cart</li>
                    <li onClick={() => navigate("/shipping")}>
                      Shipping & Returns
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md="2">
                <div className="footer_quick_links align_center">
                  <h5>Company</h5>
                  <ul>
                    <li onClick={() => navigate("/about")}>About</li>
                    <li onClick={() => navigate("/contact")}>Contact Us</li>
                    <li onClick={() => navigate("/guaranties")}>
                      Genuine Software Guarantee
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md="3" className="p-0">
                <div className="footer_quick_links align_center">
                  <h5>We Value Your Business </h5>
                  <p>
                    We prioritize upholding a standard of integrity you can
                    trust. Our team is committed to providing you with 100%
                    customer satisfaction. We work tirelessly to ensure your
                    experience with us is second to none. Thank you for choosing
                    Liberty Programs.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="footer_lower_info darkblue_bg">
          <Container>
            <ul className="mb-0 cursor_pointer align_center">
              <li onClick={() => navigate("/terms")} className="cursor_pointer">
                Terms Of Use
              </li>
              <li
                onClick={() => navigate("/privacy")}
                className="cursor_pointer align_center"
              >
                Privacy Policy
              </li>
              <li>
                <a
                  href={`${
                    apiBaseURL.split("/api/")[0]
                  }/static/product/image-1686568964857.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  EULA
                </a>
              </li>
              <li>
                <p className="mb-0 align_center">
                  © Liberty Programs 2023 | All rights reserved.{" "}
                </p>
              </li>
            </ul>
          </Container>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
